module.exports = __webpack_public_path__ + "static/media/parker-ridge.427e99f3.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/backgrounds/small/parker-ridge.png
 ** module id = 198
 ** module chunks = 0
 **/